import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lifedi-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss']
})
export class CourseCardComponent implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Input() imageUrl: string;
  @Input() teacherName: string;
  @Input() price: number;
  @Input() premiumPrice: number;
  @Input() isPremium: boolean;
  @Input() isFavorite: boolean;
  @Input() isPaid: boolean;
  @Input() haveFavorite: boolean;
  @Input() @Output() viewCourse: EventEmitter<any> = new EventEmitter();
  @Input() @Output() onFaverite: EventEmitter<any> = new EventEmitter();

  constructor(
  ) {
  }

  ngOnInit(): void {
  }

  changeFaverite() {
    this.onFaverite.emit()
  }

  view() {
    this.viewCourse.emit()
  }
}
